export const faqs = [
  {
    question: "What is MySchoolling™ School Management Software?",
    answer:
      "MySchoolling™ is a comprehensive school management platform that helps educational institutions streamline administration, improve communication, and enhance the learning experience. It includes modules for admissions, attendance, academics, examinations, fees, communication, transport, payroll, reports, and much more—all in one secure platform.",
  },

  {
    question: "Who can use MySchoolling™?",
    answer:
      "MySchoolling™ is designed for administrators, principals, teachers, students, parents, accountants, HR teams, and school management. Each user gets role-based access to the features and information relevant to them.",
  },

  {
    question: "How does the MySchoolling™ Parent App work?",
    answer:
      "The Parent App keeps parents connected with their child's education. They can monitor attendance, academic performance, homework, fee payments, notices, events, transport updates, and communicate with the school—all from a single mobile app.",
  },

  {
    question: "What can the AI Tutor help students with?",
    answer:
      "The built-in AI Tutor provides instant academic assistance by answering questions, explaining concepts, helping with homework, generating practice questions, and offering personalized learning support based on each student's needs.",
  },

  {
    question: "Can MySchoolling™ be customized for our school?",
    answer:
      "Yes. MySchoolling™ is highly customizable and can be configured for schools of all sizes, including private schools, public schools, CBSE, ICSE, state boards, international schools, and multi-campus institutions. Modules and workflows can be tailored to match your school's requirements.",
  },

  {
    question: "How long does it take to set up MySchoolling™?",
    answer:
      "Setup time depends on your school's size and data requirements. Most schools can get started within a few days. Our onboarding team assists with configuration, data import, and staff training to ensure a smooth transition.",
  },

  {
    question: "Can we import our existing student and staff data?",
    answer:
      "Yes. We can help import student records, staff information, classes, academic data, and other essential information from spreadsheets or your existing school management software, making migration simple and hassle-free.",
  },

  {
    question: "Does MySchoolling™ support online fee payments?",
    answer:
      "Yes. Parents can securely pay school fees online through integrated payment gateways. The platform also generates digital receipts, tracks payment history, and provides real-time payment notifications.",
  },

  {
    question: "Can MySchoolling™ manage attendance, exams, and report cards?",
    answer:
      "Absolutely. Schools can manage attendance, create timetables, schedule examinations, publish report cards, generate progress reports, and analyze student performance from a centralized dashboard.",
  },

  {
    question: "Can MySchoolling™ manage multiple school branches?",
    answer:
      "Yes. MySchoolling™ supports single-campus as well as multi-branch schools. Administrators can manage multiple campuses from one centralized system while maintaining separate academic and financial records for each branch.",
  },

  {
    question: "Will teachers and staff need training?",
    answer:
      "MySchoolling™ is designed with an intuitive interface that requires minimal training. We also provide onboarding sessions, documentation, and ongoing support to help your staff become productive quickly.",
  },

  {
    question: "Is MySchoolling™ secure?",
    answer:
      "Yes. Protecting your school's data is our top priority. MySchoolling™ uses secure encryption, role-based access control, regular backups, and industry-standard security practices to safeguard student, staff, and financial information.",
  },

  {
    question: "Does MySchoolling™ work on mobile and desktop devices?",
    answer:
      "Yes. MySchoolling™ is accessible through modern web browsers and dedicated mobile applications, allowing administrators, teachers, parents, and students to stay connected anytime, anywhere.",
  },

  {
    question: "What kind of customer support do you provide?",
    answer:
      "We provide onboarding assistance, product training, technical support, and regular software updates. Our support team is available to help schools resolve issues quickly and ensure smooth day-to-day operations.",
  },

  {
    question: "How much does MySchoolling™ cost?",
    answer:
      "Our pricing is flexible and depends on your school's size and requirements. Contact our team for a personalized quote or schedule a free demo to find the plan that best fits your institution.",
  },

  {
    question: "Can our school try MySchoolling™ before purchasing?",
    answer:
      "Yes. We offer free live demos so you can explore the platform, understand its features, and see how MySchoolling™ can simplify your school's operations before making a decision.",
  },
];